
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53.8 52.804"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.5 .5)"}},[_c('rect',{attrs:{"data-name":"[bg]","width":"52.8","height":"51.804","rx":"6","fill":"#fff","stroke":"#d7d7d7","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Path 29595","d":"M13 12.804h26v26H13z","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 29596","d":"M31 25.804a5 5 0 00-2.778-4.478v2.456l2.722 2.722a4.7 4.7 0 00.056-.7zm2.778 0a7.6 7.6 0 01-.6 2.933l1.678 1.678A9.774 9.774 0 0036 25.804a10 10 0 00-7.778-9.744v2.288a7.784 7.784 0 015.556 7.456zm-16.367-10L16 17.215l5.256 5.256H16v6.667h4.444L26 34.693v-7.478l4.722 4.722a7.693 7.693 0 01-2.5 1.311v2.289a9.989 9.989 0 004.1-2.011l2.267 2.278L36 34.393l-10-10zM26 16.915l-2.322 2.322L26 21.56z","fill":"#757575"}})])])
          )
        }
      }
    